const SSO_SOURCE = 'ssoSource';
const SESSION_TOKEN = 'sessionToken';
const SESSION_EXPIRES = 'sessionExpires';

export default {
  SSO_SOURCE,
  SESSION_TOKEN,
  SESSION_EXPIRES,
};
